module.exports = __webpack_public_path__ + "img/screenshot_n_52.f1030478.png";